import React from 'react'
import { observer } from 'mobx-react'
import { Card } from 'antd'
import { store } from '../../store'
import { t } from '../../config/i18n'
import { useParams } from 'react-router'
import { useOnMount } from '../../hooks/useOnMount'
import { useCatalog } from '../../hooks/useCatalog'
import { PageSettings } from '../shared/ui/PageSettings'
import { Tabs } from '../shared/ui/Tabs'
import { PageCatalogItemDetailTabMain } from './pageCatalogItemDetail/TabMain'
import { PageCatalogItemDetailTabBindings } from './pageCatalogItemDetail/TabBindings'
import { PageCatalogItemDetailTabAlerts } from './pageCatalogItemDetail/TabAlerts'
import { SingleCatalogService } from '../../services/SingleCatalogService'

export const PageCatalogItemDetail = observer(() => {
  const params = useParams()
  const { type, id, itemId } = params
  const parentId = parseInt(`${params.parentId}`) || 0
  const { catalogService, texts } = useCatalog(type, 'catalog_item_detail')
  const [tab, setTab] = React.useState('tab1')
  const isSingleCatalog = catalogService.type === 'single'
  const title = itemId === 'new' ? t.catalog.createEl : t.catalog.editEl
  const item = catalogService.store.itemDetails
  const showTabs = item.active && !!item._id

  const tabs = [
    { value: 'tab1', label: t.catalog.tabMain },
    !item.isCategory && { value: 'tab2', label: t.catalog.tabBinding },
    !item.isCategory && isSingleCatalog && { value: 'tab3', label: t.catalog.tabAlerts },
  ].filter(i => i) as TOption[]

  useOnMount(() => {
    catalogService.editCatalogItemById(id!, itemId!, parentId).catch(window.logger.error)
  })

  return (
    <PageSettings
      loading={store.ui.loading}
      title={title}
    >
      {
        showTabs
          ? (
            <Tabs
              defaultTab={tab}
              options={tabs}
              onChange={setTab}
            >
              {tab === 'tab1' && <PageCatalogItemDetailTabMain catalogService={catalogService} />}
              {!item.isCategory && (
                <>
                  {tab === 'tab2' && <PageCatalogItemDetailTabBindings catalogService={catalogService} />}
                  {tab === 'tab3' && isSingleCatalog && <PageCatalogItemDetailTabAlerts catalogService={catalogService as SingleCatalogService} />}
                </>
              )}
            </Tabs>
          )
          : (
            <Card>
              <PageCatalogItemDetailTabMain catalogService={catalogService} />
            </Card>
          )
      }
    </PageSettings>
  )
})
